import { Button, Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Comm from '../../comm/comm';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const DossierRow = ({ item, deleteFunc}) => {
    let [selected, setSelected] = useState(item.selected);

    const changeSelection = (id) => {
        Comm.Instance().post("/backend/sis/secure/artifact/selected", {
            "artifactId": id,
            "selected": !selected
        });
        setSelected(!selected);

    }

    
    return (

        <Grid container spacing={0}>
            <Grid item xs={2}>
                {item.main.number}
            </Grid>
            <Grid item xs={2}>
                {item.main.registryIndexOld}
            </Grid>
            <Grid item xs={7}>

                <Link to={`Dossier/${item.id}`}>
                    <Typography align="left">
                        {item.main.name || "Досие"}
                    </Typography>
                </Link>
            </Grid>
            <Grid item xs={1}>
                {!selected && <Button onClick={() => changeSelection(item.id)} ><CheckBoxOutlineBlankIcon></CheckBoxOutlineBlankIcon></Button>}
                {selected && <Button onClick={() => changeSelection(item.id)} ><CheckBoxIcon></CheckBoxIcon></Button>}
            </Grid>
            <Grid item xs={1} style={{display: "none"}}>
                <Button onClick={() => {
                    //deleteFunc(item.id)
                }}><DeleteForeverIcon></DeleteForeverIcon></Button>
            </Grid>

        </Grid>
    )
}

export default DossierRow;